import { render, staticRenderFns } from "./TabBottom.vue?vue&type=template&id=3d870f00&scoped=true&"
import script from "./TabBottom.vue?vue&type=script&lang=js&"
export * from "./TabBottom.vue?vue&type=script&lang=js&"
import style0 from "./TabBottom.vue?vue&type=style&index=0&id=3d870f00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d870f00",
  null
  
)

export default component.exports